import { Logger } from '@hawtiosrc/core/logging'

export const moduleName = 'hawtio-auth'
export const log = Logger.get(moduleName)

export const PUBLIC_USER = 'public'

export const PATH_USER = 'user'
export const PATH_LOGIN = 'auth/login'
export const PATH_LOGOUT = 'auth/logout'
